import { Injectable } from '@angular/core';
import {
  BuiltInPageItemDataService,
  TvSeasonPageItemDataService,
  GenrePageItemDataService,
  StudioPageItemDataService,
  CarouselPageItemDataService,
} from '@cxb/editor-stb-api';
import { Observable } from 'rxjs';
import { PageItemType } from '../domain/page-item-type';
import { Tenant } from '../domain/tenant';

@Injectable({ providedIn: 'root' })
export class TrayApiCloneService {
  constructor(
    private readonly carouselDataService: CarouselPageItemDataService,
    private readonly seasonTrayDataService: TvSeasonPageItemDataService,
    private readonly genrePageItemDataService: GenrePageItemDataService,
    private readonly studioPageItemDataService: StudioPageItemDataService,
    private readonly builtInDataService: BuiltInPageItemDataService
  ) {}

  public clonePageItem$(itemId: string, type: PageItemType, targetPageId: string, selectedTenant?: Tenant): Observable<{ id: string }> {
    switch (type) {
      case 'BuiltIn':
        return this.builtInDataService.cloneBuiltInPageItem(itemId, targetPageId);
      case 'PortraitTray':
      case 'TopTenTray':
      case 'ExpandableTray':
      case 'CollectionTray':
        return this.carouselDataService.cloneCarouselPageItem(itemId, targetPageId, selectedTenant?.id);
      case 'GenreTray':
        return this.genrePageItemDataService.cloneGenrePageItem(itemId, targetPageId, selectedTenant?.id);
      case 'StudiosTray':
        return this.studioPageItemDataService.cloneStudioPageItem(itemId, targetPageId, selectedTenant?.id);
      case 'SeasonTray':
        return this.seasonTrayDataService.cloneTvSeasonPageItem(itemId, targetPageId, selectedTenant?.id);
    }

    throw Error(`Unsupported tray type for clone: [${type}]`);
  }
}
